module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bs-drawer",
    class: _vm.sideClass
  }, [_c('div', {
    staticClass: "bs-drawer__content"
  }, [_c('div', {
    staticClass: "bs-drawer__nav-container",
    class: "bs-drawer__nav-container-" + _vm.side + " " + _vm.contentClass,
    style: ({
      backgroundColor: _vm.bg
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showToggleBtn) ? _c('div', {
    staticClass: "bs-drawer__btn-container",
    class: ("bs-drawer__btn-container-" + _vm.side)
  }, [_c('button', {
    class: [_vm.btnClass, _vm.open ? _vm.btnOpenClass : ''],
    style: (_vm.btnCustomStyle),
    on: {
      "click": _vm.toggleOpen
    }
  }, [(_vm.open) ? _vm._t("opened", [_c('svg', {
    staticClass: "bs-drawer__svg",
    attrs: {
      "width": "11.428571428571429",
      "height": "16",
      "viewBox": "0 0 1280 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"
    }
  }), _vm._v(" \b\n            ")])]) : _vm._t("closed", [_c('svg', {
    staticClass: "bs-drawer__svg",
    attrs: {
      "width": "11.428571428571429",
      "height": "16",
      "viewBox": "0 0 1280 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"
    }
  }), _vm._v(" \b\n            ")])])], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45dabff4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-bs-drawer.vue
// module id = 848
// module chunks = 1